export default __webpack_public_path__ + "static/media/GM_Bowl_Rainbow.b3ca879d.png";